import { useEffect } from 'react';
import { useTimer } from 'src/hooks/useTimer';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { TimerState } from 'src/recoil/join';

const TimerWrap = styled.div`
  position: absolute;
  color: #f63240;
  line-height: 60px;
  right: 20%;
`;

const Timer = (props: { onFinish?: () => void }) => {
  const { onFinish } = props;
  const isTimer = useRecoilValue(TimerState);
  const { formatTime, delay } = useTimer(isTimer);

  useEffect(() => {
    if (delay !== 0) return;

    const id = setTimeout(() => {
      onFinish?.();
    }, 1000);
    return () => clearTimeout(id);
  }, [delay, onFinish]);

  return (
    <TimerWrap>
      <span>{formatTime}</span>
    </TimerWrap>
  );
};

export default Timer;
